<template>
  <div v-if="user" class="min-h-screen bg-gray-100">
    <SidebarMenu
      :user="user"
      :isMenuOpen="isMenuOpen"
      @toggle-menu="toggleMenu"
      @close-menu="closeMenu"
      @logout="logout"
    />

    <!-- Contenido Principal - ajustado para tener margen izquierdo en escritorio -->
    <div class="md:ml-64">
      <main class="p-4">
        <div class="p-4">
          <h1 class="text-xl font-bold">Historial Académico</h1>
          <p class="text-gray-600 mb-4">Matrícula: {{ studentId }}</p>

          <div v-if="loading" class="flex justify-center my-8">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>

          <div v-else-if="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {{ error }}
          </div>

          <div v-else-if="data && data.length > 0" class="overflow-x-auto">
            <h2 class="text-lg font-semibold mb-2">Periodos:</h2>
            <table class="min-w-full border-collapse border border-gray-300">
              <thead class="bg-gray-200">
                <tr>
                  <th class="border p-2">Periodo</th>
                  <th class="border p-2">Descripción</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in data" :key="item.idPeriod">
                  <td class="border p-2">{{ item.idPeriod }}</td>
                  <td class="border p-2">{{ item.description }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div v-else class="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded mb-4">
            No hay periodos disponibles para mostrar.
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SidebarMenu from '@/components/SidebarMenu.vue';
import { getPeriods } from "@/services/api";

export default {
  components: {
    SidebarMenu
  },
  data() {
    return {
      user: null,
      isMenuOpen: false,
      data: null,
      loading: true,
      error: null,
      studentId: null
    };
  },
  async created() {
    await this.getUserFromBackend();
  },
  methods: {
    async getUserFromBackend() {
      try {
        const response = await axios.get('/me');
        this.user = response.data.user;
        
        // Extraer el ID de estudiante
        if (this.user.email && this.user.email.match(/^a(\d+)@/)) {
          this.studentId = this.user.email.match(/^a(\d+)@/)[1];
          // Cargar datos con el ID extraído
          await this.loadData();
        } else {
          this.error = "No se pudo extraer el ID de estudiante del email.";
          this.loading = false;
        }
      } catch (error) {
        console.error("Error obteniendo usuario", error);
        this.$router.push('/login');
      }
    },
    async loadData() {
      try {
        const response = await getPeriods({ idstudent: this.studentId });
        this.data = response.data;
        this.loading = false;
      } catch (error) {
        console.error("Error al obtener los datos:", error);
        this.error = "Error al cargar los datos. Por favor, intente nuevamente.";
        this.loading = false;
      }
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    async logout() {
      try {
        // Obtener nuevo token CSRF
        await axios.get('/sanctum/csrf-cookie');

        // Esperar un momento para asegurar que la cookie se haya establecido
        await new Promise(resolve => setTimeout(resolve, 100));

        // Realizar la petición de logout
        const response = await axios.post('/logout', {}, {
          withCredentials: true,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });
        console.log(response);
        // Limpiar cookies locales
        document.cookie.split(";").forEach(function(c) { 
          document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        // Redirigir al login
        this.$router.push('/login');
      } catch (error) {
        console.error('Error al cerrar sesión:', error.response?.data || error);
      }
    }
  }
};
</script>